import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { TribunaleaAuthProvider } from "@tribunalea/auth/react";
import {
  CreditExhaustionProvider,
  RouterProvider,
  ToastProvider,
} from "@tribunalea/ui";
import App from "./App.jsx";
import "@tribunalea/ui/styles.css";
import "@tribunalea/ui/expedientes.css";
import "./styles.css";

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const accountCreditsUrl = `${import.meta.env.VITE_ACCOUNT_URL || (
  import.meta.env.DEV
    ? "http://localhost:5175"
    : "https://account.tribunalea.com"
)}/creditos`;
const liveContent = (
  <RouterProvider>
    <App authEnabled />
  </RouterProvider>
);
const demoContent = (
  <RouterProvider>
    <App authEnabled={false} />
  </RouterProvider>
);

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <CreditExhaustionProvider creditsHref={accountCreditsUrl}>
      <ToastProvider>
        <TribunaleaAuthProvider
          publishableKey={clerkPublishableKey}
          apiUrl={import.meta.env.VITE_API_URL || "http://localhost:4000"}
          demoFallback={demoContent}
        >
          {liveContent}
        </TribunaleaAuthProvider>
      </ToastProvider>
    </CreditExhaustionProvider>
  </StrictMode>,
);
